// extracted by mini-css-extract-plugin
export default {"code":"WebhookLog_code__IJRCb","codeBack":"WebhookLog_codeBack__Xeu9e","codeHeader":"WebhookLog_codeHeader__oMFU2"};